import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Modal from '../../UniformComponents/Modal'
import Input from '../form/Input'
import Button from '../../UniformComponents/Button'
import ModalFooter from '../../UniformComponents/ModalFooter'
import ModalHeader from '../../UniformComponents/ModalHeader'
import RadioGroup from '../form/RadioGroup'

@observer
class CreateDashboardWizard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dashboardTitle: '',
            templateSetting: 'private',
        }
    }

    changeTitle = ({ value }) => {
        this.setState({ dashboardTitle: value })
    }

    close = () => {
        const { dashStore } = this.props
        const { toggleShowCreateDashboard } = dashStore
        toggleShowCreateDashboard()
    }

    openSelectTemplate = () => {
        const { dashStore } = this.props
        const { toggleShowCreateDashboard, toggleShowTemplateSelection } = dashStore
        toggleShowTemplateSelection()
        toggleShowCreateDashboard()
    }

    save = () => {
        const { dashStore } = this.props
        const { toggleShowCreateDashboard, createNewDashboard, appStore } = dashStore
        const { dashboardTitle, templateSetting } = this.state
        if (!dashboardTitle) {
            appStore.addNotification(null, 'Must enter a dashboard title', 'error')
            return
        }

        createNewDashboard(dashboardTitle, templateSetting === 'public')
        this.setState({ templateSetting: 'private' }) // important to reset state to avoid confusion if second dashbaord created
        toggleShowCreateDashboard()
    }

    render() {
        const { dashStore } = this.props
        const { showCreateDashboard, getChartScope, oId } = dashStore
        return (
            <Modal
                show={showCreateDashboard}
                onClose={this.close}
                cssClass="dashboardCreationWizard"
            >
                <ModalHeader cssClass="chartAdvancedPreview-header ">
                    <div className="title">
                        {i18n.t('dashboards.createDashbaord.title')}
                    </div>
                    <div className="subTitle">
                        {i18n.t('dashboards.createDashbaord.subTitle')}
                    </div>
                </ModalHeader>
                <div className="body">
                    <Input
                        label="Dashboard title"
                        onChange={this.changeTitle}
                    />
                    {oId > 3
                        ? (
                            <div className="dashboardTemplateControls">
                                <RadioGroup
                                    onBlur={({ value }) => this.setState({ templateSetting: value })}
                                    defaultChecked="private"
                                    options={[
                                        { value: 'private', label: `Available for this ${getChartScope(oId)} only` },
                                        { value: 'public', label: `Available for all ${getChartScope(oId)}s` },
                                    ]}
                                />
                            </div>
                        )
                        : null }
                </div>
                <ModalFooter>
                    <Button
                        label={(
                            <div style={{ marginRight: '15px' }}>
                                <i style={{ marginRight: '10px' }} className="fa-regular fa-gauge-simple-high" />
                                {i18n.t('dashboards.createDashbaord.selectTemplate')}
                            </div>
                        )}
                        cssClass="tertiary regular"
                        onClick={this.openSelectTemplate}
                    />
                    <Button
                        label={(
                            <div style={{ marginRight: '15px' }}>
                                <i style={{ marginRight: '10px' }} className="fa-regular fa-circle-plus" />
                                {i18n.t('dashboards.createDashbaord.startFromScratch')}
                            </div>
                        )}
                        cssClass="primary regular saveDash"
                        onClick={this.save}
                    />
                </ModalFooter>
            </Modal>
        )
    }
}

export default CreateDashboardWizard
